import { ApplicationState } from '../../store/store';
import { Client } from './types';

export const getClientById = (state: ApplicationState, id: number): Client | undefined => state.clients.byId[id];
export const getAllClients = (state: ApplicationState): Client[] => state.clients.allIds.map(id => getClientById(state, id)).filter(x => x != null) as Client[];
export const getAllClientById = (state: ApplicationState): Record<number, Client> => state.clients.byId;
export const areClientsLoading = (state: ApplicationState): boolean => state.clients.loading;
export const isSavingClient = (state: ApplicationState): boolean => state.clients.saving;